import { render } from "./Partiners.vue?vue&type=template&id=4fa58186&scoped=true"
import script from "./Partiners.vue?vue&type=script&lang=js"
export * from "./Partiners.vue?vue&type=script&lang=js"

import "./Partiners.vue?vue&type=style&index=0&id=4fa58186&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/fundraise/front_end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fa58186"]])

export default __exports__